import { render, staticRenderFns } from "./UserInfoEdit.vue?vue&type=template&id=56c52b90"
import script from "./UserInfoEdit.vue?vue&type=script&lang=js"
export * from "./UserInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports